function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
export var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);
    this._listeners = new Map();
  }
  _createClass(EventDispatcher, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      this.removeEventListener(type, listener);
      var arr = this._listeners.get(type);
      if (!arr) {
        arr = [];
        this._listeners.set(type, arr);
      }
      arr.push(listener);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, args) {
      var listeners = this._listeners.get(type);
      listeners && listeners.forEach(function (handler) {
        return handler(args);
      });
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(type) {
      return !!this._listeners.get(type);
    }
  }, {
    key: "removeAllEventListeners",
    value: function removeAllEventListeners(type) {
      if (!type) {
        this._listeners = new Map();
      } else {
        this._listeners["delete"](type);
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var arr = this._listeners.get(type);
      if (!arr) {
        return;
      }
      var length = arr.length,
        idx = arr.indexOf(listener);
      if (idx < 0) {
        return;
      }
      if (length === 1) {
        this._listeners["delete"](type);
      } else {
        arr.splice(idx, 1);
      }
    }
  }]);
  return EventDispatcher;
}();